"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISIBLE_TIME_KEY = exports.SESSION_VALID_TIME = exports.SESSION_ID_KEY = void 0;
// session id 存储 key
exports.SESSION_ID_KEY = "si";
exports.SESSION_VALID_TIME = 30 * 60 * 1000; // 半小时
exports.VISIBLE_TIME_KEY = "visibleTime";
